import HomeComponentsView from './home_components_view';

export default HomeComponentsView;
